// __BOARD_DRAFTS__ (2026-10-16) the hub's drafts for the board's Drafts column, through the hub's OWN routes with the
// signed-in person's token -- GET /api/drafts?all=true (everybody's for a login with the hub's "see all drafts"
// permission, otherwise only their own; the hub decides) and DELETE /api/drafts/<id> (your own, or any with that
// permission). The hub answers this site cross-origin for exactly these two (app.py __BOARD_DRAFTS__).
// Opening a draft hands the session to the hub (the board's usual hand-off, utils/auth.js) with #open-draft=<id>:
// the hub opens it in its Bookings form, where Create Job turns it into a job.
import { supabase } from '../supabaseClient';

export const HUB = 'https://hub.hmgc.io';

const token = async () => {
  const { data } = await supabase.auth.getSession();
  return (data && data.session && data.session.access_token) || '';
};

// { ok, drafts, scope: 'all' | 'mine' } | { ok: false, status, message }
export async function listDrafts() {
  const t = await token();
  if (!t) return { ok: false, status: 401, message: 'Not signed in.' };
  try {
    const r = await fetch(HUB + '/api/drafts?all=true', { headers: { Authorization: 'Bearer ' + t }, redirect: 'manual' });
    if (r.type === 'opaqueredirect' || r.status === 0) return { ok: false, status: 401, message: 'The hub did not accept this sign-in.' };
    let j = null;
    try { j = await r.json(); } catch (e) { j = null; }
    if (r.status === 200 && j && j.success && Array.isArray(j.drafts)) {
      return { ok: true, drafts: j.drafts.filter((d) => d && d.id), scope: j.scope === 'all' ? 'all' : 'mine' };
    }
    return { ok: false, status: r.status, message: (j && j.error) || ('The hub answered ' + r.status + '.') };
  } catch (e) {
    return { ok: false, status: 0, message: 'The hub could not be reached (' + ((e && e.message) || 'network') + ').' };
  }
}

export async function deleteDraft(id) {
  const t = await token();
  if (!t) return { ok: false, message: 'Not signed in.' };
  try {
    const r = await fetch(HUB + '/api/drafts/' + encodeURIComponent(id), { method: 'DELETE', headers: { Authorization: 'Bearer ' + t }, redirect: 'manual' });
    let j = null;
    try { j = await r.json(); } catch (e) { j = null; }
    if (r.status === 200 && j && j.success) return { ok: true, message: '' };
    return { ok: false, message: (j && j.error) || ('The hub answered ' + r.status + '.') };
  } catch (e) {
    return { ok: false, message: 'The hub could not be reached (' + ((e && e.message) || 'network') + ').' };
  }
}

// The hub's booking form with this draft in it, in a new tab (the session goes with it, as the Billing button does).
export function draftHubUrl(id, accessToken, refreshToken) {
  const frag = '#open-draft=' + encodeURIComponent(String(id || ''));
  if (!accessToken) return HUB + '/' + frag;
  return HUB + '/?token=' + encodeURIComponent(accessToken) + '&refresh_token=' + encodeURIComponent(refreshToken || '') + frag;
}

export async function openDraftInHub(id) {
  const win = window.open('about:blank', '_blank');       // opened in the click, so it is not blocked as a pop-up
  const { data } = await supabase.auth.getSession();
  const s = data && data.session;
  const url = draftHubUrl(id, s && s.access_token, s && s.refresh_token);
  if (win) { try { win.opener = null; } catch (e) { /* ignore */ } win.location.href = url; } else window.location.href = url;
}
